import { o as e, s as t, t as n } from "./_plugin-vue_export-helper-CAW4dcA9.js";
import { CardList as r, ROUTES as i, VuetifyValidationRules as a, getI18n as o, quasarValidateRules as s } from "@editor/ui-utils";
import { QBtn as c, QCard as l, QCardActions as u, QCardSection as d, QDialog as f, QIcon as p, QInput as m, useFormChild as h } from "quasar";
import { Fragment as g, computed as _, createBlock as v, createCommentVNode as y, createElementBlock as b, createElementVNode as x, createTextVNode as S, createVNode as C, defineAsyncComponent as w, defineComponent as T, mergeModels as E, normalizeClass as D, onBeforeMount as O, openBlock as k, ref as A, toDisplayString as j, unref as M, useModel as N, watch as P, withCtx as F } from "vue";
import { useI18n as I } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var L = {
	en: {
		videoPageApi: {
			createAlreadyExists: "The Video page cannot be created because a video page with this video already exists.",
			updateAlreadyExists: "The Video page cannot be updated because a video page with this video already exists.",
			created: "Video page created",
			updated: "Video page updated",
			notFound: "Video page not found",
			requiredFields: "You cannot save the Video page because required fields are missing."
		},
		videoPageList: {
			newButton: "New Video page",
			select: "Select Video page",
			name: "Search for title or legacy ID",
			deleteVideoPage: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading Video page",
			headerStatus: "Status",
			headerLabel: "Video page",
			headerChannel: "Channel",
			headerShownDate: "Shown Date",
			headerCreatedAt: "Created at",
			headerChangedAt: "Changed at",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			editNewTab: "Edit in new tab",
			dpGoToVideoPage: "Go to Video Page",
			copyVideoPageUrl: "Copy video page URL",
			copiedVideoPageUrl: "Video page URL copied",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error on deleting",
			createVideoPage: "Create Video page",
			duplicateVideoPage: "Duplicate video page"
		},
		videoPage: {
			videoPageLabel: "Video page",
			backButton: "Back to Video page list",
			newVideoPage: "New Video page",
			messageDeleteVideoPage: "Delete Video page",
			messageDeleteVideoPageTitle: "Are you sure you want to delete this Video page?",
			deleteVideoPage: "Delete",
			messageDeleted: "Video page Deleted",
			errorOnDeleting: "There was an error deleting the Video page",
			errorFailedLoadedVideoPageWithId: "There was an error getting the Video page",
			handledInLegacySystem: "This video page is handled in the legacy system ({source})"
		},
		videoPageEdit: {
			title: "Title",
			leadText: "Lead Text",
			slug: "URL Slug",
			pathConflictNotice: {
				template: "This path is in conflict with {pathType} path of another video page. Only {pathRoutable} video page will be reachable!",
				pathTypeCurrent: "the current",
				pathTypeOld: "an old",
				pathRoutableThis: "this",
				pathRoutableOther: "the other"
			},
			seoTitle: "SEO Title",
			seoDescription: "Meta Description",
			markAsAd: "Mark as ad",
			hideFromTeaserList: "Hide from most recent",
			isNoIndex: "Activate NoIndex",
			isAdsEnabled: "Ads enabled",
			editVideoPage: "Edit Video page",
			messageSaved: "New Video page saved",
			savePublish: "Publish",
			saveScheduled: "Schedule publication",
			teaserVideoTitle: "Preview video",
			teaserVideoTitleTooltip: "The preview video is displayed on the video page.",
			videoSelector: "Select or upload video",
			teaserImageTitle: "Teaser image",
			teaserImageTitleTooltip: "The teaser image is displayed on channel pages.",
			teaserImageSelector: "Select or upload teaser image",
			selectedPartnerImageWarning: "You have selected partner image. This image may only be used in the corresponding partner article.",
			channel: "Channel",
			secondaryChannels: "Secondary Channels",
			communityTracking: "Community tracking",
			general: "General",
			updateShownDateCheckbox: "Update shown date",
			updateShownDateCheckboxHint: "Automatically update the shown date to the current timestamp when you save or publish the video page.",
			seoUrlSettings: "URL & SEO",
			canonicalUrl: "Canonical URL",
			dateSettingsTitle: "Publishing settings",
			videoPageDisplayDate: "Shown date",
			setPublishDate: "Publish at",
			setUnpublishDate: "Take offline at",
			shownAfterPublicationDateValidationMessage: "Shown date cannot be after publish date",
			shownAfterCurrentDateValidationMessage: "Shown date cannot be in the future",
			unpublishDateMustBeInFuture: "Unpublish date must be in the future",
			saveDraft: "Save as Draft",
			saveOffline: "Take offline",
			deleteVideoPage: "Delete Video page",
			modeUnpublished: "Video page offline",
			modeScheduled: "Publishing date scheduled",
			modePublished: "Published",
			modeDraft: "Draft",
			noIndexActivated: "The NoIndex option has been enabled for the duplicated video page.",
			messagePreview: "Please save your video page to see changes in preview.",
			community: "Community",
			viewPage: "View Page"
		},
		common: {
			basics: "Basics",
			settings: "Settings",
			save: "Save",
			cancel: "Cancel",
			preview: "Preview",
			previewMobile: "Mobile",
			previewTablet: "Tablet",
			previewDesktop: "Desktop",
			history: "History",
			publish: "Publish",
			publishDialogMessage: "Do you want to publish these changes?",
			saveDraft: "Save as Draft",
			saveDraftDialogMessage: "Do you want to save these changes as a draft?",
			unpublish: "Unpublish",
			unpublishDialogMessage: "Do you want to take this page offline?",
			error: "Error"
		},
		pathSelector: { pathAutogenerate: "Auto-generate URL" },
		videoPageNotifications: { successfulMutation: {
			saved: "Video page saved",
			deleted: "Deleted",
			published: "Published",
			unpublished: "Video page offline",
			scheduled: "Scheduled",
			saveDraft: "Draft"
		} }
	},
	de: {
		videoPageApi: {
			createAlreadyExists: "Videoseite kann nicht erstellt werden, da bereits eine Videoseite mit diesem Video existiert.",
			updateAlreadyExists: "Videoseite kann nicht aktualisiert werden, da bereits eine Videoseite mit diesem Video existiert.",
			created: "Videoseite erstellt",
			updated: "Videoseite aktualisiert",
			notFound: "Videoseite nicht gefunden",
			requiredFields: "Sie können die Videoseite nicht speichern, da Pflichtfelder fehlen."
		},
		videoPageList: {
			newButton: "Neue Videoseite",
			select: "Videoseite auswählen",
			name: "Suchen nach Titel oder Legacy-ID",
			deleteVideoPage: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Lade Videoseite",
			headerStatus: "Status",
			headerLabel: "Videoseite",
			headerChannel: "Channel",
			headerShownDate: "Shown Date",
			headerCreatedAt: "Erstellt am",
			headerChangedAt: "Geändert",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			editNewTab: "In neuem Tab bearbeiten",
			dpGoToVideoPage: "Zur Videoseite",
			copyVideoPageUrl: "Videoseiten-URL kopieren",
			copiedVideoPageUrl: "Videoseiten-URL kopiert",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createVideoPage: "Videoseite erstellen",
			duplicateVideoPage: "Videoseite duplizieren"
		},
		videoPage: {
			videoPageLabel: "Videoseite",
			backButton: "Zurück zur Videoseiten-Liste",
			newVideoPage: "Neue Videoseite",
			messageDeleteVideoPage: "Videoseite löschen",
			messageDeleteVideoPageTitle: "Sind Sie sicher, dass Sie diese Videoseite löschen möchten?",
			deleteVideoPage: "Löschen",
			messageDeleted: "Videoseite gelöscht",
			errorOnDeleting: "Es gab einen Fehler beim Löschen der Videoseite",
			errorFailedLoadedVideoPageWithId: "Es gab einen Fehler beim Aufrufen der Videoseite",
			handledInLegacySystem: "Diese Videoseite wird im Legacy-System ({source}) verwaltet"
		},
		videoPageEdit: {
			title: "Titel",
			leadText: "Vorspann",
			slug: "URL-Slug",
			pathConflictNotice: {
				template: "Dieser Pfad überschneidet sich mit {pathType} Pfad einer anderen Videoseite. Nur {pathRoutable} Videoseite ist erreichbar!",
				pathTypeCurrent: "dem aktuellen",
				pathTypeOld: "einem alten",
				pathRoutableThis: "diese",
				pathRoutableOther: "die andere"
			},
			seoTitle: "SEO-Titel",
			seoDescription: "Meta Description",
			markAsAd: "Als Anzeige markieren",
			hideFromTeaserList: "Nicht im Teaser-Listing anzeigen",
			isNoIndex: "NoIndex aktivieren",
			isAdsEnabled: "Werbung aktivieren",
			editVideoPage: "Videoseite bearbeiten",
			messageSaved: "Neue Videoseite gespeichert",
			savePublish: "Veröffentlichen",
			saveScheduled: "Veröffentlichung planen",
			teaserVideoTitle: "Hauptvideo",
			teaserVideoTitleTooltip: "Das Hauptvideo wird auf der Videoseite angezeigt.",
			videoSelector: "Video auswählen oder hochladen",
			teaserImageTitle: "Teaserbild",
			teaserImageTitleTooltip: "Das Teaserbild wird auf Channelseiten angezeigt.",
			teaserImageSelector: "Teaserbild auswählen oder hochladen",
			selectedPartnerImageWarning: "Sie haben ein Partnerbild ausgewählt. Dieses Bild darf nur in dem entsprechenden Partnerartikel verwendet werden.",
			channel: "Channel",
			secondaryChannels: "Sekundäre Channels",
			communityTracking: "Community Zuordnung",
			general: "Allgemein",
			updateShownDateCheckbox: "Shown Date aktualisieren",
			updateShownDateCheckboxHint: "Shown Date wird bei Speichern oder Veröffentlichen automatisch aktualisiert.",
			seoUrlSettings: "URL & SEO",
			canonicalUrl: "Canonical URL",
			dateSettingsTitle: "Veröffentlichung",
			videoPageDisplayDate: "Shown date",
			setPublishDate: "Publish date",
			setUnpublishDate: "Offline nehmen am",
			shownAfterPublicationDateValidationMessage: "Shown date kann nicht nach dem Veröffentlichungsdatum liegen",
			shownAfterCurrentDateValidationMessage: "Shown date kann nicht in der Zukunft liegen",
			unpublishDateMustBeInFuture: "Offline-Datum muss in der Zukunft liegen",
			saveDraft: "Als Entwurf speichern",
			saveOffline: "Videoseite offline nehmen",
			deleteVideoPage: "Videoseite löschen",
			modeUnpublished: "Offline genommen",
			modeScheduled: "Veröffentlichung geplant",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf",
			noIndexActivated: "Die NoIndex-Option wurde für die duplizierte Videoseite aktiviert.",
			messagePreview: "Bitte speichern Sie Ihre Videoseite, um Änderungen in der Vorschau zu sehen.",
			community: "Community",
			viewPage: "Seite anzeigen"
		},
		common: {
			basics: "Basics",
			settings: "Einstellungen",
			save: "Speichern",
			cancel: "Abbrechen",
			preview: "Vorschau",
			previewMobile: "Mobil",
			previewTablet: "Tablet",
			previewDesktop: "Desktop",
			history: "Verlauf",
			publish: "Veröffentlichen",
			publishDialogMessage: "Möchten Sie diese Änderungen veröffentlichen?",
			saveDraft: "Als Entwurf speichern",
			saveDraftDialogMessage: "Möchten Sie diese Änderungen als Entwurf speichern?",
			unpublish: "Offline nehmen",
			unpublishDialogMessage: "Möchten Sie diese Seite offline nehmen?",
			error: "Fehler"
		},
		pathSelector: { pathAutogenerate: "URL automatisch generieren" },
		videoPageNotifications: { successfulMutation: {
			saved: "Videoseite gespeichert",
			deleted: "Gelöscht",
			published: "Veröffentlicht",
			unpublished: "Videoseite offline",
			scheduled: "Geplant",
			saveDraft: "Entwurf"
		} }
	}
}, R = [{
	path: `/${i.videoPages.path}`,
	meta: { i18RouteTitleKey: i.videoPages.path },
	children: [
		{
			path: "",
			name: "video_page_list",
			component: () => import("./video-page-list.view-BUPjIvhr.js"),
			meta: { requiredRight: "video-pages:navigate" }
		},
		{
			path: "new",
			name: "video_page_new",
			component: () => import("./video-page-edit.view-1sAzdDGd.js"),
			props: (e) => ({
				title: o().t("videoPage.newVideoPage"),
				tab: e.query.tab,
				xymaticId: Array.isArray(e.query.id) ? e.query.id[0] : e.query.id
			}),
			meta: { requiredRight: ["video-pages:navigate"] }
		},
		{
			path: ":id",
			name: "video_page_detail",
			component: () => import("./video-page-edit.view-1sAzdDGd.js"),
			props: (e) => ({
				title: o().t("videoPageEdit.editVideoPage"),
				id: e.params.id,
				tab: e.query.tab
			}),
			meta: { requiredRight: ["video-pages:navigate"] }
		}
	]
}], z = { class: "row justify-center items-center align-center text-center" }, B = { class: "col-6" }, V = {
	key: 0,
	class: "required"
}, H = /* @__PURE__ */ n(/* @__PURE__ */ T({
	__name: "video-page-list.selector",
	props: /* @__PURE__ */ E({
		rules: { default: () => [] },
		brand: { default: void 0 },
		required: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: { default: "" },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(n) {
		let r = w(() => import("./video-page-edit.view-1sAzdDGd.js")), i = w(() => import("./video-page-list.view-BUPjIvhr.js")), o = n, g = N(n, "modelValue"), { t: _ } = I(), T = A(!1), E = A(!1), P = A(!0), L = A(e()), R = A(""), H = A(), U = () => {
			let e = o.rules.concat(o.required ? [a.required] : []), t = s(L.value, e);
			P.value = !t, R.value = t;
		};
		h({
			validate() {
				return U(), P.value || H.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), P.value;
			},
			resetValidation() {
				P.value = !0;
			}
		});
		let W = () => {
			o.disable || (E.value = !0);
		}, G = (e) => {
			L.value = e, E.value = !1, g.value = L.value._id, U();
		}, K = () => {
			E.value = !1, T.value = !1;
		}, q = () => {
			L.value = e(), g.value = void 0, K();
		}, J = () => {
			T.value = !0;
		}, Y = (e) => {
			e && (T.value = !1, E.value = !1, L.value = e, g.value = e._id, U());
		};
		return O(async () => {
			g.value && (L.value = await t(g.value));
		}), (e, t) => (k(), b("div", {
			ref_key: "wrapper",
			ref: H
		}, [C(M(l), {
			flat: "",
			bordered: "",
			class: D({ invalid: !P.value })
		}, {
			default: F(() => [g.value ? (k(), v(M(d), {
				key: 1,
				class: "full-height q-mt-md",
				"data-qa-video-page-picker": ""
			}, {
				default: F(() => [
					C(M(m), {
						modelValue: L.value.title,
						"onUpdate:modelValue": t[0] ||= (e) => L.value.title = e,
						class: "q-mb-sm",
						disable: "",
						dense: "",
						flat: "",
						"hide-details": "",
						outlined: "",
						solo: ""
					}, null, 8, ["modelValue"]),
					C(M(m), {
						modelValue: L.value._id,
						"onUpdate:modelValue": t[1] ||= (e) => L.value._id = e,
						class: "q-mb-sm",
						disable: "",
						dense: "",
						flat: "",
						"hide-details": "",
						outlined: "",
						solo: ""
					}, null, 8, ["modelValue"]),
					C(M(m), {
						modelValue: L.value.brand,
						"onUpdate:modelValue": t[2] ||= (e) => L.value.brand = e,
						error: !P.value,
						"error-message": R.value,
						class: "q-mb-sm",
						disable: "",
						dense: "",
						flat: "",
						"hide-details": "",
						outlined: "",
						solo: "",
						onBlur: U
					}, null, 8, [
						"modelValue",
						"error",
						"error-message"
					]),
					n.disable ? y("", !0) : (k(), v(M(u), {
						key: 0,
						class: "row items-center justify-center"
					}, {
						default: F(() => [C(M(c), {
							"text-color": "secondary",
							icon: "edit",
							class: "q-mx-sm bg-white",
							color: "primary",
							label: M(_)("videoPageList.dpEdit"),
							outline: "",
							"data-qa-video-page-edit-button": "",
							onClick: t[3] ||= (e) => E.value = !0
						}, null, 8, ["label"]), C(M(c), {
							"text-color": "secondary",
							icon: "trash",
							class: "q-mx-sm bg-white",
							color: "primary",
							label: M(_)("common.remove"),
							disable: n.disable,
							outline: "",
							"data-qa-video-page-clear-button": "",
							onClick: q
						}, null, 8, ["label", "disable"])]),
						_: 1
					}))
				]),
				_: 1
			})) : (k(), v(M(d), {
				key: 0,
				class: "full-height q-mt-md",
				"data-qa-complex-picker": "",
				onClick: W
			}, {
				default: F(() => [x("div", z, [x("div", B, [L.value.title ? y("", !0) : (k(), v(M(p), {
					key: 0,
					color: "grey-5",
					name: "globe",
					size: "36px"
				})), L.value.title ? y("", !0) : (k(), v(M(d), {
					key: 1,
					flat: "",
					class: "q-pa-sm",
					color: "white"
				}, {
					default: F(() => [S(j(M(_)("videoPage.videoPageLabel")) + " ", 1), n.required ? (k(), b("span", V)) : y("", !0)]),
					_: 1
				}))])])]),
				_: 1
			}))]),
			_: 1
		}, 8, ["class"]), C(M(f), {
			modelValue: E.value,
			"onUpdate:modelValue": t[4] ||= (e) => E.value = e,
			container: "",
			"data-qa-edit-video-page-dialog": "",
			"full-height": "",
			"full-width": "",
			onHide: K
		}, {
			default: F(() => [!g.value && !T.value ? (k(), v(M(i), {
				key: 0,
				brand: n.brand,
				dialog: !0,
				"disable-brand-filter": !0,
				onClose: K,
				"onClick:videoPage": G,
				"onClick:videoPage:new": J
			}, null, 8, ["brand"])) : g.value ? (k(), v(M(r), {
				key: 2,
				id: g.value,
				dialog: !0,
				title: M(_)("videoPageEdit.editVideoPage"),
				"onBack:modal": K,
				onSaveVideoPage: Y
			}, null, 8, ["id", "title"])) : (k(), v(M(r), {
				key: 1,
				dialog: !0,
				title: M(_)("videoPageList.createVideoPage"),
				"onBack:modal": K,
				onSaveVideoPage: Y
			}, null, 8, ["title"]))]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-26e4eb1a"]]), U = /* @__PURE__ */ T({
	__name: "video-page-picker.selector",
	props: {
		modelValue: { default: void 0 },
		brand: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: n }) {
		let i = w(() => import("./video-page-list.view-BUPjIvhr.js")), a = e, o = n, { t: s } = I(), l = A(!1), u = A(), d = _(() => [{
			_id: u.value?._id ?? "",
			kicker: s("videoPage.videoPageLabel"),
			title: u.value?.title ?? "",
			imageUuid: u.value?.listingImageUuid ?? void 0
		}]), p = (e) => {
			u.value = e, o("update:modelValue", e._id), l.value = !1;
		}, m = () => {
			u.value = void 0, o("update:modelValue", void 0);
		};
		return P(() => a.modelValue, async (e) => {
			e ? u.value = await t(e) : u.value = void 0;
		}), O(async () => {
			a.modelValue && (u.value = await t(a.modelValue));
		}), (t, n) => (k(), b(g, null, [
			e.modelValue ? y("", !0) : (k(), v(M(c), {
				key: 0,
				"text-color": "secondary",
				icon: "plus",
				color: "primary",
				class: "q-mr-sm bg-white",
				label: M(s)("videoPageList.select"),
				outline: "",
				disable: e.disable,
				onClick: n[0] ||= (e) => l.value = !0
			}, null, 8, ["label", "disable"])),
			e.modelValue ? (k(), v(M(r), {
				key: 1,
				items: d.value,
				disable: e.disable,
				onRemoveItem: m
			}, null, 8, ["items", "disable"])) : y("", !0),
			C(M(f), {
				"model-value": l.value,
				"full-width": "",
				"full-height": "",
				onHide: n[3] ||= (e) => l.value = !1
			}, {
				default: F(() => [C(M(i), {
					brand: e.brand,
					dialog: !0,
					"disable-brand-filter": !0,
					"onClick:videoPage": p,
					onClose: n[1] ||= (e) => l.value = !1,
					"onBack:modal": n[2] ||= (e) => l.value = !1
				}, null, 8, ["brand"])]),
				_: 1
			}, 8, ["model-value"])
		], 64));
	}
}), W = {
	messages: L,
	routes: R
};
//#endregion
export { H as VideoPageListSelector, U as VideoPagePickerSelector, W as videoPageModule };

//# sourceMappingURL=index.es.js.map